export interface FileData {
  id: string
  name: string
  type: string
  size: string
  uploadedAt: string
  source: 'whatsapp' | 'upload'
}

export const mockFiles: FileData[] = [
  {
    id: '1',
    name: 'Q4 Marketing Strategy.pdf',
    type: 'application/pdf',
    size: '2.4 MB',
    uploadedAt: '2 hours ago',
    source: 'whatsapp'
  },
  {
    id: '2',
    name: 'Product Demo Screenshots.png',
    type: 'image/png',
    size: '1.8 MB',
    uploadedAt: '5 hours ago',
    source: 'upload'
  },
  {
    id: '3',
    name: 'Annual Budget 2024.xlsx',
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    size: '856 KB',
    uploadedAt: '1 day ago',
    source: 'whatsapp'
  },
  {
    id: '4',
    name: 'Company Presentation.pptx',
    type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    size: '3.2 MB',
    uploadedAt: '2 days ago',
    source: 'upload'
  },
  {
    id: '5',
    name: 'Team Meeting Recording.mp4',
    type: 'video/mp4',
    size: '45.7 MB',
    uploadedAt: '3 days ago',
    source: 'whatsapp'
  },
  {
    id: '6',
    name: 'Contract Agreement.docx',
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    size: '1.2 MB',
    uploadedAt: '1 week ago',
    source: 'upload'
  }
]

export const mockStorageData = {
  usedSpace: 8.7,
  totalSpace: 50,
  unit: 'GB' as const
}

export const mockStats = {
  recentItemsCount: 15,
  totalItems: mockFiles.length
}

export interface Collection {
  id: string
  title: string
  icon: string
  color: string
  items: Partial<CollectionItemDetail>[]
}

export interface CollectionItemDetail {
  id: string
  name: string
  imagePath: string
  url?: string
  description: string
  dateCreated: string
}

export const mockCollections: Collection[] = [
  {
    id: '1',
    title: 'Product Designs',
    icon: '🎨',
    color: '#3b82f6',
    items: [
      { id: '1'},
      { id: '2'},
      { id: '3'}
    ]
  },
  {
    id: '2',
    title: 'Saved Docs',
    icon: '📄',
    color: '#10b981',
    items: [
      { id: '4' },
      { id: '5' },
      { id: '6' }
    ]
  },
  {
    id: '3',
    title: 'Drawings',
    icon: '✏️',
    color: '#8b5cf6',
    items: [
      { id: '7' },
      { id: '8' },
      { id: '9' }
    ]
  },
  {
    id: '4',
    title: 'Outdoors',
    icon: '🏔️',
    color: '#f59e0b',
    items: [
      { id: '10' },
      { id: '11' },
      { id: '12' }
    ]
  },
  {
    id: '5',
    title: 'Renovating',
    icon: '🔨',
    color: '#ef4444',
    items: [
      { id: '13' },
      { id: '14' },
      { id: '15' }
    ]
  },
  {
    id: '6',
    title: 'UX',
    icon: '📱',
    color: '#06b6d4',
    items: [
      { id: '16' },
      { id: '17' },
      { id: '18' }
    ]
  }
]

export const mockCollectionItems: CollectionItemDetail[] = [
    {
      id: '1',
      name: 'Design Mood Board',
      imagePath: '/images/collections/product-designs/bindery-moodboard.svg',
      url: 'https://lawsofux.com/',
      description: 'A comprehensive mood board showcasing design inspirations and visual direction for the upcoming product line.',
      dateCreated: 'October 2, 2025'
    },
    {
      id: '2',
      name: 'UX Research Session',
      imagePath: '/images/collections/product-designs/ux-research.svg',
      url: 'https://lawsofux.com/',
      description: 'Documentation from user research sessions including interview notes, findings, and actionable insights.',
      dateCreated: 'September 28, 2025'
    },
    {
      id: '3',
      name: 'Camping Setup Design',
      imagePath: '/images/collections/product-designs/camping-setup.svg',
      description: 'Innovative camping gear layout designs focusing on portability and user experience in outdoor environments.',
      dateCreated: 'September 25, 2025'
    },
    {
      id: '4',
      name: 'Mobile App Wireframes',
      imagePath: '/images/user-journey.svg',
      url: 'https://figma.com/design-system',
      description: 'Low-fidelity wireframes for the mobile companion app, showing key user flows and interface layouts.',
      dateCreated: 'September 22, 2025'
    },
    {
      id: '5',
      name: 'Product Photography',
      imagePath: '/images/mountain-photos.svg',
      description: 'High-quality product shots and lifestyle photography for marketing materials and e-commerce.',
      dateCreated: 'September 18, 2025'
    },
    {
      id: '6',
      name: 'Brand Identity Guidelines',
      imagePath: '/images/design-system.svg',
      url: 'https://brand.design.com',
      description: 'Complete brand identity system including logos, color palette, typography, and usage guidelines.',
      dateCreated: 'September 15, 2025'
    },
    {
      id: '7',
      name: 'Project Requirements',
      imagePath: '/images/requirements.svg',
      url: 'https://docs.company.com/requirements',
      description: 'Detailed project requirements document outlining scope, deliverables, and success criteria.',
      dateCreated: 'October 1, 2025'
    },
    {
      id: '8',
      name: 'Meeting Notes Q4',
      imagePath: '/images/meeting-notes.svg',
      description: 'Comprehensive notes from quarterly planning meetings including action items and decisions made.',
      dateCreated: 'September 30, 2025'
    },
    {
      id: '9',
      name: 'Technical Specifications',
      imagePath: '/images/tech-specs.svg',
      url: 'https://tech.specs.com',
      description: 'Technical documentation covering system architecture, API specifications, and implementation details.',
      dateCreated: 'September 26, 2025'
    },
    {
      id: '10',
      name: 'Budget Proposal',
      imagePath: '/images/requirements.svg',
      description: 'Financial planning document with budget breakdown, cost estimates, and resource allocation.',
      dateCreated: 'September 20, 2025'
    },
    {
      id: '11',
      name: 'Architecture Sketch',
      imagePath: '/images/architecture-sketch.svg',
      description: 'Hand-drawn architectural concepts and structural design ideas for the new office space.',
      dateCreated: 'October 3, 2025'
    },
    {
      id: '12',
      name: 'Character Design',
      imagePath: '/images/character-design.svg',
      url: 'https://artstation.com/character-design',
      description: 'Original character illustrations and concept art for the upcoming animated project.',
      dateCreated: 'September 29, 2025'
    },
    {
      id: '13',
      name: 'Floor Plan Draft',
      imagePath: '/images/floor-plan.svg',
      description: 'Detailed floor plan sketches showing room layouts, dimensions, and spatial relationships.',
      dateCreated: 'September 24, 2025'
    }
]